var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwOptimists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 327,
    viewBox: "0 0 328 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.459 323.917C252.078 323.917 323.917 252.078 323.917 163.459C323.917 74.8398 252.078 3 163.459 3C74.8399 3 3 74.8398 3 163.459C3 252.078 74.8399 323.917 163.459 323.917Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M324.782 163.169C324.782 251.813 252.967 323.628 164.323 323.628C75.6789 323.628 3.86426 251.813 3.86426 163.169",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.615 163.169C266.615 219.605 220.77 265.451 164.333 265.451C107.897 265.451 62.0518 219.605 62.0518 163.169",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.399 163.169C215.399 191.46 192.477 214.382 164.186 214.382C135.895 214.382 112.973 191.46 112.973 163.169",
    fill: "#FF6B35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M317.103 3H10.6935C6.68718 3 3.43945 6.24773 3.43945 10.254V316.663C3.43945 320.67 6.68718 323.917 10.6935 323.917H317.103C321.109 323.917 324.357 320.67 324.357 316.663V10.254C324.357 6.24773 321.109 3 317.103 3Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwOptimists);
export default __webpack_public_path__ + "static/media/dfw-Optimists.0cb4cece7f5f47f5ef073eb683b2b97c.svg";
export { ForwardRef as ReactComponent };